/**
 * Google Ads Conversion Tracking
 *
 * Server-side GA4 Measurement Protocol for conversion tracking.
 * Google Ads receives conversions via GA4 import.
 */

export { default as googleAdsService } from './GoogleAdsService'
export {
    CONVERSION_LABELS,
    GoogleAdsConversionEvent,
    type ConversionConfig,
    type ConversionParams,
} from './conversions'
export {
    hashSHA256,
    normalizeEmail,
    normalizePhone,
    normalizeName,
    prepareUserData,
    type EnhancedUserData,
    type HashedUserData,
} from './enhancedConversions'
